import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LayerMenuItem, MapColors, GeoModule } from '@next/arable-lib/geo';

import { SiteState } from '@next/core-lib/site';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';

import { setBlightLayerEnabled, setCropFieldsLayerEnabled, setSoilAnalysesLayerEnabled } from './store/map.actions';
import { getBlightLayerEnabled, getCropFieldsLayerEnabled, getSoilAnalysisLayerEnabled } from './store/map.selectors';
import { SummaryCardComponent } from '@next/core-lib/components';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
    selector: 'app-widget-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        SummaryCardComponent,
        GeoModule,
        TranslatePipe,
    ],
})
export class MapComponent implements OnInit, OnDestroy {
  private readonly store = inject<Store<SiteState>>(Store);

  destroy$ = new Subject<boolean>();
  layerMenuItems: LayerMenuItem[] = [
    {
      key: 'fieldsLayer',
      label: 'fieldsLayer',
      formControl: new FormControl({ value: true, disabled: false }),
      action: (val: unknown) => setCropFieldsLayerEnabled(val as boolean),
      selector: getCropFieldsLayerEnabled,
      layers: [{ label: 'Fields', color: MapColors.viewStroke }],
      colors: [MapColors.viewStroke],
    },
    {
      key: 'blightLayer',
      label: 'blightLayer',
      formControl: new FormControl({ value: true, disabled: false }),
      action: (val: unknown) => setBlightLayerEnabled(val as boolean),
      selector: getBlightLayerEnabled,
      layers: [
        {
          label: 'blightLayer',
          color: MapColors.blightPreventiveStroke,
        },
      ],
      layerOpacity: 0.8,
      colors: [MapColors.blightPreventiveStroke],
    },
    {
      key: 'soilAnalysesLayer',
      label: 'soilAnalysesLayer',
      formControl: new FormControl({ value: false, disabled: false }),
      action: (val: unknown) => setSoilAnalysesLayerEnabled(val as boolean),
      selector: getSoilAnalysisLayerEnabled,
      layers: [{ label: 'soilAnalysis', color: MapColors.soilAnalysesStroke }],
      colors: [MapColors.soilAnalysesStroke],
    },
  ];

  ngOnInit() {
    this.updateChangingValues();
  }

  updateChangingValues() {
    this.layerMenuItems.forEach((menuItem) => {
      if (menuItem.formControl && menuItem.action) {
        menuItem.formControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
          // @ts-ignore: allow menuItem.action to be used as a constructor
          this.store.dispatch(menuItem.action(value));
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
